import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';
import { colors } from '../styles/color-tokens';

const theme = createTheme({
  components: {
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.surface.base,
        },
      },
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          color: colors.text.primary,
        },
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          color: colors.text.primary,
        },
        switchViewIcon: {
          color: colors.text.primary,
        },
      },
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          color: colors.text.primary,
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          color: colors.text.primary,
          '&.Mui-disabled:not(.Mui-selected)': {
            color: colors.text.disabled,
          },
          '&.Mui-selected': {
            backgroundColor: colors.primary.main,
            '&:hover': {
              backgroundColor: colors.primary.hover,
            },
            '&:focus': {
              backgroundColor: colors.primary.hover,
            },
          },
        },
        today: {
          color: colors.text.primary,
          border: `1px solid ${colors.primary.main} !important`,
          '&:hover': {
            backgroundColor: colors.primary.hover,
          },
        },
      },
    },
    MuiMonthCalendar: {
      styleOverrides: {
        button: {
          color: colors.text.primary,
        },
      },
    },
    MuiYearCalendar: {
      styleOverrides: {
        button: {
          color: colors.text.primary,
        },
      },
    },
    MuiPickersInputBase: {
      styleOverrides: {
        root: {
          color: colors.text.primary,
          border: `1px solid ${colors.border.default}`,
          '& .MuiPickersOutlinedInput-root': {
            border: `1px solid ${colors.primary.main}`,
          },
        },
        sectionsContainer: {
          padding: '8px 0 !important',
        },
      },
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.surface.elevated,
          '& .MuiPickersOutlinedInput-notchedOutline': {
            border: `1px solid ${colors.background.surface.elevated}`,
          },
          '&:hover .MuiPickersOutlinedInput-notchedOutline': {
            border: `1px solid ${colors.primary.hover}`,
          },
          '&.Mui-focused:not(.Mui-error) .MuiPickersOutlinedInput-notchedOutline': {
            border: `1px solid ${colors.primary.main}`,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: colors.text.primary,
          '&.Mui-focused': {
            color: colors.primary.main,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primary.main,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: colors.text.primary,
        },
        root: {
          '& .MuiSelect-select': {
            color: colors.text.primary,
          },
        },
      },
    },
    MuiNativeSelect: {
      styleOverrides: {
        icon: {
          color: colors.text.primary,
        },
      },
    },
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.surface.base,
          color: colors.text.primary,
        },
      },
    },
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.surface.base,
          color: colors.text.primary,
        },
      },
    },
  },
});

export default theme;
